<template>
  <div>
    <div class="ll-box">
    <!-- breadcrumb -->
    <div class="breadcrumb-top">
      <b-breadcrumb class="">
        <b-breadcrumb-item :to="{ name: 'dashboard' }">
          <feather-icon
            icon="HomeIcon"
            size="16"
          />
        </b-breadcrumb-item>
        <b-breadcrumb-item>
          {{ $t('Chargeable Order') }}
        </b-breadcrumb-item>
        <b-breadcrumb-item active >
          {{ $t('Order List') }}
        </b-breadcrumb-item>
      </b-breadcrumb>
    </div>
    <!-- Add Btn -->
      <div class="d-flex justify-content-end">
        <b-button
          variant="info"
          :to="{ name: 'add-charge' }"
          v-permission="[162]"
        >
          <span class="text-nowrap">{{ $t('Create New Invoice') }}</span>
        </b-button>
      </div>
    </div>
    <!-- Filters -->
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col md="6">
            <b-input-group>
              <b-input-group-prepend
                is-text
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                v-b-toggle.filterS
                class="ll-outline"
                :style="filterBg">
                <svg class="ll-ficon" aria-hidden="true">
                  <use xlink:href="#icon-filter"></use>
                </svg>
              </b-input-group-prepend>
              <b-form-input
                v-model="condition.refNo"
                class="searchInput"
                placeholder="Please Enter TKID"
              />
              <b-input-group-prepend
                is-text
                class="ll-searchBtn"
                @click="searchById">
                <feather-icon
                  icon="SearchIcon"
                  class="mr-25"
                  size="18"
                />
              </b-input-group-prepend>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- Filters sidebar -->
    <b-sidebar id="filterS" title=""
      right
      shadow
      bg-variant="white"
      backdrop>
      <div class="px-3">
         <app-collapse class="ll-collapse">
          <app-collapse-item :title="$t('Status')">
            <v-select
              id="status"
              :options="statusList"
              label="name"
              @input="selStatus"
              v-model="status"
              placeholder="Please Select Status"
            ></v-select>
          </app-collapse-item>
          <app-collapse-item :title="$t('Invoice Type')">
            <v-select
              id="type"
              :options="typeList"
              label="invoiceType"
              @input="selType"
              v-model="invoiceType"
              placeholder="Please Select Invoice Type"
            ></v-select>
          </app-collapse-item>
          <app-collapse-item :title="$t('Creation Date from-to')">
            <b-row>
              <b-col>
                <flat-pickr
                  id="formTime"
                  v-model="beginDate"
                  class="form-control"
                  :config="{ enableTime: true,dateFormat: 'Y-m-d H:i:ss'}"
                />
              </b-col>
              <b-col>
                <flat-pickr
                  id="toTime"
                  v-model="endDate"
                  class="form-control"
                  :config="{ enableTime: false,dateFormat: 'Y-m-d H:i:ss'}"
                />
              </b-col>
            </b-row>
          </app-collapse-item>
         </app-collapse>
      <div class="ll-btn">
        <b-button
          variant="secondary"
          class="mr-1"
          @click="onClear"
        >
          {{ $t('Clear') }}
        </b-button>
        <b-button variant="info"
          v-b-toggle.filterS
          @click="filterSearch">
          {{ $t('Search') }}
        </b-button>
      </div>
      </div>
    </b-sidebar>
    <b-table
      ref="refUserListTable"
      class="position-relative ll-table"
      :items="rows"
      :fields="columns"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
      :striped="true"
      :hover="true"
      :borderless='true'
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @sort-changed="onSortChange"
      v-permission="[161]"
      :sticky-header="true"
      :busy="isBusy"
      @row-clicked="onDetail"
    >
      <template #table-busy>
        <div class="text-center my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      <!-- tags -->
      <template #cell(tag)="row" v-if="false">
        <b-badge
          pill
          :variant="`light-${color}`"
          class="ll-badge"
          v-for="(item, index) of row.value"
          :key="index">
          <span v-if="item !== null">{{ item }}</span>
        </b-badge>
      </template>
      <!-- Column: Actions -->
      <template #cell(action)="data">
        <feather-icon
          :id="`${data.item.id}`"
          icon="EyeIcon"
          size="16"
          class="mx-1"
          @click="$router.push({ name: 'charge-detail', params: { id: data.item.tkID }})"
          v-permission="[163]"
        />
        <b-tooltip
          title="View Details"
          :target="`${data.item.id}`"
        />
      </template>
    </b-table>
    <div class="d-flex justify-content-between flex-wrap ll-p">
      <div class="d-flex align-items-center mb-0 mr-1">
        <span class="text-nowrap ">
          Showing 1 to
        </span>
        <b-form-select
          v-model="size"
          :options="pageOptions"
          class="mx-1"
          @input="handlePageChange"
        />
        <span class="text-nowrap"> of {{ totalSize }} entries </span>
      </div>
      <div>
        <b-pagination
          v-model="page"
          :total-rows="totalSize"
          :per-page="size"
          first-number
          last-number
          class="mb-0 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
          @change="handleChangePage"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BButton,
  BTooltip,
  BCard,
  BCardBody,
  BRow,
  BCol,
  BSidebar,
  VBToggle,
  BTable,
  BInputGroupPrepend,
  BInputGroup,
  BBreadcrumb,
  BBreadcrumbItem,
  BBadge,
  BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'
import Ripple from 'vue-ripple-directive'
import permission from '@core/directives/permission/index.js'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

export default {
  components: {
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BButton,
    BTooltip,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BSidebar,
    vSelect,
    flatPickr,
    BTable,
    BInputGroupPrepend,
    BInputGroup,
    BBreadcrumb,
    BBreadcrumbItem,
    BBadge,
    AppCollapse,
    AppCollapseItem,
    BSpinner,
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    permission,
  },
  props: {
    color: {
      type: String,
      default: 'primary',
    },
  },
  data() {
    return {
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      pageOptions: [50, 100, 200],
      page: null, // 当前页码
      size: 15, // 每页个数
      totalSize: null, // 总个数
      totalPage: null, // 总页数
      columns: [
        { key: 'invoiceType', label: this.$t('Invoice Type'), sortable: true },
        { key: 'feeType', label: this.$t('Fee type'), sortable: true },
        { key: 'status', label: this.$t('Status'), sortable: true },
        { key: 'tkID', label: this.$t('TKID'), sortable: true },
        // { key: 'refNo', label: 'Ref No', sortable: true },
        // { key: 'refNoType', label: 'Ref No Type', sortable: true },
        // { key: 'tkQty', label: 'TKID Qty', sortable: true },
        { key: 'amount', label: this.$t('Amount'), sortable: true },
        { key: 'createdAt', label: this.$t('Creation Date'), sortable: true },
        { key: 'operator', label: this.$t('Operator'), sortable: true },
        { key: 'action', label: this.$t('Action'), class: 'll-action' },
      ],
      rows: [],
      searchTerm: '',
      statusList: [
        { value: 0, name: '未发' },
        { value: 1, name: '已发' },
      ],
      typeList: [],
      formTime: '',
      toTime: '',
      condition: {
        page: '1',
        size: '50',
        orderBy: 'id',
        orderMole: 0,
        status: null,
        invoiceType: null,
        beginDate: null,
        endDate: null,
        refNo: null,
      },
      status: '',
      invoiceType: '',
      beginDate: '',
      endDate: '',
      filterBg: {
        '--background': '#fff'
      },
      isBusy: true,
    }
  },
  computed: {},
  watch: {
    'invoiceType'(val) {
      this.setBg(val)
    },
    'status'(val) {
      this.setBg(val)
    },
    'beginDate'(val) {
      this.setBg(val)
    },
    'endDate'(val) {
      this.setBg(val)
    },
  },
  created() {
  },
  mounted() {
    this.getList()
    this.queryIntype()
  },
  methods: {
    // filter图标背景颜色设置
    setBg(val) {
      if (val !== null && val !== '') {
        this.filterBg= {
          '--background': '#ff9f43'
        }
      } else {
        this.filterBg= {
          '--background': '#fff'
        }
      }
    },
    // 首次查询
    getList() {
      this.$http.post('invoiceDetail/search', this.condition).then(res => {
        // console.log('ss', res.data.data)
        if (res.data.code === '10001') {
          this.$router.push({ name: 'auth-login' })
        } else if (res.data.code === '200') {
          const info = res.data.data
          this.rows = info.content
          this.page = info.page
          this.size = info.size
          this.totalSize = info.totalSize
          this.totalPage = info.totalPage
          this.isBusy = false
        }
      }).catch(error => console.log(error))
    },
    queryIntype() {
      this.$http.get('invoiceDetail/search/getInvoiceTypeList').then(res => {
        // console.log(res.data.data)
        this.typeList = res.data.data
      })
    },
    // 点击单行
    onRowClick() {
      // console.log('onRowClick')
    },
    onSearch() {
      // console.log('onSearch')
    },
    onClear() {
      this.invoiceType = ''
      this.status = ''
      this.beginDate = ''
      this.endDate = ''
    },
    // 条件过滤搜索
    filterSearch() {
      // this.condition.status = this.status
      // this.condition.invoiceType = this.invoiceType
      this.condition.beginDate = this.beginDate
      this.condition.endDate = this.endDate
      console.log(this.condition)
      this.getList()
    },
    // 根据TKID查询
    searchById() {
      this.condition.refNo = this.condition.refNo.trim()
      this.getList()
    },
    // 排序规则
    onSortChange(params) {
      const orderBy = params.sortBy
      const orderMole = params.sortDesc ? 0 : 1
      this.condition.orderBy = orderBy
      this.condition.orderMole = orderMole
      this.getList()
      return params.sortDesc ? 0 : 1
    },
    handleChangePage(page) {
      this.condition.page = page
      this.getList()
    },
    handlePageChange(active) {
      this.condition.size = active
      this.getList()
    },
    selType(t) {
      // console.log(t)
      this.condition.invoiceType = t.invoiceType
    },
    selStatus(t) {
      // console.log(t)
      this.condition.status = t.value
      this.status = t.name
    },
    onDetail(item){
      this.$router.push({ name: 'charge-detail', params: { id: item.tkID }})
    },
  },
}
</script>
<style scoped>
/* .ll-p{
  position: fixed;
  bottom: 40px;
  right: 10px;
} */
.ll-btn{
  position: fixed;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding-right: 6rem;
  width: 100%;
}
.ll-btnS{
  margin-right: 20px;
}
.ll-colBox{
  margin: auto;
}
.ll-outline{
  outline: none;
}
.ll-searchBtn div{
  background-color: #ff9f43;
  color: #fff;
  width: 60px;
  display: flex;
  justify-content: center;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
}
.ll-box{
  display: flex;
  align-items: start;
  justify-content: space-between;
  margin-bottom: 10px;
}
.ll-outline> div{
  background: var(--background);
}
</style>
<style>
[dir] .vgt-table.bordered th{
  padding: 10px;
  font-size: 12px;
}
table.vgt-table{
  font-size: 12px;
}
[dir=ltr] .b-sidebar.b-sidebar-right > .b-sidebar-header .close{
  margin-left: unset;
  margin-right: unset;
  font-size: 20px;
}
[dir=ltr] .b-sidebar.b-sidebar-right{
  width: 25%;
}
[dir] .page-item.active{
  height: 27px;
}
.table thead th, .table tfoot th {
  text-transform: capitalize;
}
</style>
